import { Form } from 'antd';
import { IColProps, IFormItemProps, IRules, ValidateStatus } from '../entities';

//validation helper => Utils/validationHelper in components

const FormItem = Form.Item;

const BCFormItem = (props: IFormItemProps) => (
	<FormItem
		noStyle={props.noStyle}
		shouldUpdate={props.shouldUpdate}
		wrapperCol={props.wrapperCol}
		labelCol={props.labelCol}
		key={props.itemkey}
		hasFeedback={props.hasFeedback ? true : false}
		validateStatus={props.validateStatus ? props.validateStatus : ValidateStatus.validating}
		help={props.validateStatus ? props.help : undefined}
		label={props.label}
		colon={props.colon}
		required={props.required}
		className={props.className}
		style={props.style}
		labelAlign={props.labelAlign}
		name={props.name}
		rules={props.rules}
		getValueFromEvent={props.getValueFromEvent}
		data-selenium-id={props.seleniumId}
		initialValue={props.initialValue}
		dependencies={props.dependencies}
	>
		{props.children}
	</FormItem>
);
export default BCFormItem;
export { IColProps, IFormItemProps, ValidateStatus, IRules };
